/**
 * @title membership-number.js: Sub-module of Account feature
 * @description This module provides validation and utilities regarding membership number
 * @dependency utility.js
 */
define([], function() {
  let MembershipNumber = {
    init: function() {
      this.tiresHomeUrl = 'https://tires.costco.com';
    },

    membershipNumberUpdateCmd: '/AjaxMembershipNumberUpdateCmd',
    /**
     * This is used by the Add Membership Modal window
     * to build a modal and add / validate a membership
     * to a user's account.
     * @return {[void]}
     */
    start: function() {
      $('#membershipNumberVerifyError').hide();
      let cancelButton = COSTCO.AddMembershipNumberStatic.CANCEL;
      let continueButton = COSTCO.AddMembershipNumberStatic.CONTINUE;
      $('#addMemberNumber').dialog({
        title: COSTCO.AddMembershipNumberStatic.ADDMEMBERSHIPNUMBER_Title,
        show: {
          effect: 'fade',
          duration: 500,
        },
        hide: {
          effect: 'fade',
          duration: 500,
        },
        resizable: false,
        minHeight: 'auto',
        width: 500,
        draggable: false,
        position: 'center',
        modal: true,
        buttons: [{
            'text': cancelButton,
            'class': 'rl_modalCancelButton',
            'click': function() {
              $(this).dialog('close');
            },
          },
          {
            'text': continueButton,
            'class': 'rl_modalButton',
            'click': function() {
              COSTCO.MembershipNumber.updateMembershipNumber();
            },
          },
        ],
        open: function(event) {
          $('div.ui-dialog-buttonpane').css('margin', '0 0 0 0');
          $('div.ui-dialog-content').css('padding', '0 0 0 0');
        },
      });
      $('#membershipNumberToAdd').keypress(function() {
        $('#membershipNumberToAddError').hide();
      });
      $('div.ui-dialog-buttonpane').css('margin', '0 0 0 0');
      $('div.ui-dialog-content').css('padding', '0 0 0 0');
    },
    submitRequest: function(urlWithParams, successFunction) {
      COSTCO.util.LoginTimeout.checkTimeout();
      $.ajax({
        type: 'POST',
        url: urlWithParams,
        dataType: 'json',
        success: function(data) {
          COSTCO.util.LoginTimeout.updateActivity();
          successFunction(data);
        },
        error: function(x, t, m) {
          COSTCO.util.LoginTimeout.updateActivity();
          if (t === 'timeout') {
            console.log('Error timeout.');
          } else {
            console.log('Error');
          }
        },
      });
    },
    costcoMembershipNumber: function(value) {
      return /^\d{12,16}$/.test(value);
    },
    updateMembershipNumber: function() {
      if (COSTCO.MembershipNumber.costcoMembershipNumber($('#membershipNumberToAdd').val())) {
        let url = COSTCO.MembershipNumber.membershipNumberUpdateCmd + '?membershipNumber=' + $('#membershipNumberToAdd').val();
        COSTCO.MembershipNumber.submitRequest(url, COSTCO.MembershipNumber.reload);
      } else {
        $('#membershipNumberToAddError').show();
      }
    },
    reload: function(data) {
      if (data.success) {
        COSTCO.MembershipNumber.forwardToTiresURL();
      } else {
        $('#membershipNumberToAddError').show();
      }
    },

    forwardToTiresURL: function() {
      const url = COSTCO.util.getParameterByName('URL');
      if (url) {
        window.location.href = DOMPurify.sanitize(url);
      } else {
        window.location.href = this.tiresHomeUrl;
      }
    },

    updateMembershipNumberForTires: function() {
      COSTCO.MembershipNumber.updateMembershipNumber();
    },
  };
  if (typeof window.COSTCO == 'undefined') {
    window.COSTCO = {};
  }

  window.COSTCO.MembershipNumber = MembershipNumber;
  return MembershipNumber;
});



// WEBPACK FOOTER //
// ./js/account/membership-number.js